import { Badge } from '@/components/ui/badge'
import { Field, FieldDescription, FieldError, FieldGroup, FieldLabel } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { PhoneInput } from '@/components/ui/phoneInput'

export interface ContactsDraft {
  email: string
  phone: string
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** True once something is typed that is not yet a usable address. */
function hasBadAddress(value: string): boolean {
  const addresses = value
    .split(',')
    .map((address) => address.trim())
    .filter(Boolean)
  return addresses.length > 0 && !addresses.every((address) => EMAIL.test(address))
}

export const STEP_CONTACTS_QUESTION =
  'Where should we send expiration reminders, discovered gaps, and document requests?'

/** Step 1: who the vault writes to once it starts watching. */
export function StepContacts({
  value,
  onChange,
}: {
  value: ContactsDraft
  onChange: (next: ContactsDraft) => void
}) {
  return (
    <FieldGroup className="max-w-sm">
      <Field data-invalid={hasBadAddress(value.email)}>
        <FieldLabel htmlFor="vault-contact-email">Email</FieldLabel>
        <Input
          id="vault-contact-email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="owner@yourfleet.com"
          value={value.email}
          onChange={(event) => onChange({ ...value, email: event.target.value })}
          aria-invalid={hasBadAddress(value.email)}
        />
        {hasBadAddress(value.email) ? (
          <FieldError>That does not look like an email address.</FieldError>
        ) : (
          <FieldDescription>Separate several addresses with commas.</FieldDescription>
        )}
      </Field>
      <Field>
        <FieldLabel htmlFor="vault-contact-phone" className="gap-2">
          Phone number
          <Badge variant="secondary">Coming soon</Badge>
        </FieldLabel>
        {/* Stored, but nothing texts off it yet: the chase digest is email only. */}
        <PhoneInput
          id="vault-contact-phone"
          autoComplete="tel"
          disabled
          value={value.phone}
          onChange={(next) => onChange({ ...value, phone: next || '' })}
        />
      </Field>
    </FieldGroup>
  )
}
